import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { Provider } from "react-redux";
import { persistor, store } from "./components/Slices";
import { PersistGate } from "redux-persist/integration/react";
import { BrowserRouter } from "react-router-dom";
import ErrorBoundary from "./ErrorBoundary";
import InspectProtector from "./InspectProtector";
import { applyTheme, getTheme, watchTheme } from "./theme";
import { watchChartTheme } from "./chartTheme";

applyTheme(getTheme());
watchTheme();
watchChartTheme();
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <BrowserRouter>
        <ErrorBoundary>
          <InspectProtector>
            <App />
          </InspectProtector>
        </ErrorBoundary>
      </BrowserRouter>
    </PersistGate>
  </Provider>
);
